<template>
  <section id="adjudicacion-formas" class="a-ways" aria-labelledby="adjudicacion-ways-title">
    <header class="a-ways__header">
      <h2 id="adjudicacion-ways-title" class="wd-title">Formas de adjudicación</h2>
      <p class="wd-body">
        Existen diferentes modalidades de adjudicación diseñadas para adaptarse al avance de cada cliente. Conoce cómo
        puedes acercarte a la entrega de tu patrimonio según tu historial y progreso dentro del financiamiento.
      </p>
    </header>

    <div class="a-ways__grid">
      <article v-for="item in items" :key="item.title" class="a-ways__card">
        <div class="a-ways__body">
          <h3 class="a-ways__title">{{ item.title }}</h3>
          <p class="wd-body">
            <strong>{{ item.subtitle }}</strong> {{ item.text }}
          </p>
        </div>
        <img class="a-ways__strip" :src="stripImage" alt="" aria-hidden="true" />
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
import stripImage from '../../../assets/adjudicacion-figma/strip.png'

const items = [
  {
    title: 'Natural',
    subtitle: 'Tu constancia habla por ti.',
    text: 'Mientras más pagos mantengas al corriente, más cerca estás de recibir tu patrimonio. Y si llega un empate, tu antigüedad puede marcar la diferencia.'
  },
  {
    title: 'Lista de espera',
    subtitle: 'Tu avance también abre oportunidades.',
    text: 'A partir de 54 cuotas pagadas, puedes integrarte a la lista de espera y acercarte antes a la meta de tener tu hogar.'
  },
  {
    title: 'Obligatoria',
    subtitle: 'Tu compromiso acelera el camino.',
    text: 'Con 60 cuotas pagadas o anticipadas, y manteniendo puntualidad en tus pagos, aumentan tus posibilidades de adjudicación.'
  },
  {
    title: 'Directa',
    subtitle: 'Hay momentos donde la tranquilidad importa más que nunca.',
    text: 'En casos de fallecimiento o invalidez, la adjudicación puede aplicarse al titular o sus beneficiarios.'
  },
  {
    title: 'Por liquidación',
    subtitle: 'Cuando decides dar el último paso, todo cambia.',
    text: 'Al completar el pago total de tu financiamiento, el proceso de adjudicación se realiza de forma inmediata.'
  }
]
</script>

<style scoped>
.a-ways {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-7);
}
.a-ways__header {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-5);
}

.a-ways__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--ds-space-7);
}

.a-ways__card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--ds-grey-50);
  border-radius: 24px;
}
.a-ways__body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--ds-space-4);
  padding: var(--ds-space-5);
}
.a-ways__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}
.a-ways__body .wd-body strong {
  font-weight: 600;
}
.a-ways__strip {
  display: block;
  flex: 0 0 32px;
  width: 100%;
  height: 32px;
  object-fit: cover;
}

@media (max-width: 1024px) {
  .a-ways {
    gap: var(--ds-space-6);
  }
  .a-ways__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 599px) {
  .a-ways__grid {
    grid-template-columns: 1fr;
    gap: var(--ds-space-6);
  }
}
</style>
